import { render, staticRenderFns } from "./case-remark.vue?vue&type=template&id=0f753960&scoped=true"
import script from "./case-remark.vue?vue&type=script&lang=ts"
export * from "./case-remark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f753960",
  null
  
)

export default component.exports